import _ from 'lodash'
import * as namespaceMapping from '../common/namespaceMapping'
import * as cssPropertySchemas from '../dist/schemas/cssPropertySchemas.json'
import * as cssValueDefinitions from '../dist/schemas/css-value-definitions.schema.json'
const {NAMESPACE_MAPPING, ALIAS_NAMESPACES, OVERRIDE_NAMESPACES} = namespaceMapping

const MAP_NAME_TO_NAMESPACE = _.invert(NAMESPACE_MAPPING)
const SCHEMA_TO_NAMESPACE = _(NAMESPACE_MAPPING)
    .mapValues((v, namespace) => namespace)
    .assign(MAP_NAME_TO_NAMESPACE)
    .value()

const VIRTUAL_NAMESPACES = _.keys(ALIAS_NAMESPACES).concat(_.keys(OVERRIDE_NAMESPACES))

function getSchemasByDataType(allSchemas: any = {}, includeCommonSchemas = false) {
    const {structure, componentsDefinitionsMap} = allSchemas

    const schemaToNamespace = {...SCHEMA_TO_NAMESPACE}
    if (includeCommonSchemas) {
        schemaToNamespace.common = 'common'
        schemaToNamespace.commonSchemas = 'commonSchemas'
    }

    const namespacesSchemas = _(allSchemas) //sometimes we get <namespace, schemas> and sometimes we get <dataMapName, schemas>
        .pickBy((v, k) => schemaToNamespace[k])
        .mapKeys((v, k) => schemaToNamespace[k])
        .value()

    const aliasedNamespaces = _.pick(allSchemas, VIRTUAL_NAMESPACES) //these schemas exist only in the non-client-only configs

    return _.pickBy(
        {
            definition: componentsDefinitionsMap,
            componentsDefinitionsMap,
            allComponentsDefinitionsMap: componentsDefinitionsMap,
            structure,
            cssPropertySchemas,
            cssValueDefinitions,
            ...namespacesSchemas,
            ...aliasedNamespaces
        },
        _.identity
    )
}

const arrangeSchemasByDataType = (rawSchemas: any, includeCommonSchemas = false) =>
    getSchemasByDataType(rawSchemas, includeCommonSchemas)

/**
 * just remove the .json for now
 * soon this function will be removed completely
 */
const convertSchemaNamesToOldStyleFileNames = (schemasWithNewStyleNames: any) =>
    _.mapKeys(schemasWithNewStyleNames, (v, k) => k.replace('.json', ''))
const arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames = (schemas: any, includeCommonSchemas = false) =>
    arrangeSchemasByDataType(convertSchemaNamesToOldStyleFileNames(schemas), includeCommonSchemas)
export {
    arrangeSchemasByDataType,
    convertSchemaNamesToOldStyleFileNames,
    arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames
}
